export default __webpack_public_path__ + "static/media/ECw-Winner-9.5d3b3b0b.png";